import { render, staticRenderFns } from "./ConfirmView.vue?vue&type=template&id=b03dda08&scoped=true&"
import script from "./ConfirmView.vue?vue&type=script&lang=js&"
export * from "./ConfirmView.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmView.vue?vue&type=style&index=0&id=b03dda08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03dda08",
  null
  
)

export default component.exports